/* Lomamo Black Friday: non-invasive variant-aware euro savings. */
(function () {
  'use strict';
  var langs = { nl: 'nl-NL', de: 'de-DE', fr: 'fr-FR', en: 'en-GB' };

  function init() {
    document.querySelectorAll('[data-lomamo-euro-saving]').forEach(function (el) {
      if (el.dataset.lomamoReady === '1') return;
      var section = el.closest('.js-product-section');
      var form = section && section.querySelector('[data-product-form]');
      var select = form && form.querySelector('[data-variants]');
      var priceUI = section && section.querySelector('.product-block--price [data-price-ui]');
      if (!form || !select || !priceUI) return;
      var product;
      try { product = JSON.parse(form.getAttribute('data-product') || '{}'); } catch (e) { return; }
      if (!Array.isArray(product.variants)) return;
      el.dataset.lomamoReady = '1';
      var threshold = Number(el.dataset.thresholdCents);
      if (!Number.isFinite(threshold)) threshold = 30000;
      var amountEl = el.querySelector('[data-lomamo-euro-amount]');
      var lng = el.dataset.language || 'nl';
      var lang = langs[lng] || 'nl-NL';
      var currency = el.dataset.currency || 'EUR';

      function refresh() {
        var selected = product.variants.find(function (v) {
          return String(v.id) === String(select.value);
        });
        var price = selected && Number(selected.price);
        var compare = selected && Number(selected.compare_at_price);
        var eligible = !!(selected && selected.available && Number.isFinite(price) &&
          Number.isFinite(compare) && compare > price && price >= threshold);
        el.hidden = !eligible;
        if (eligible) {
          var saving = compare - price;
          amountEl.textContent = new Intl.NumberFormat(lang, {
            style: 'currency', currency: currency
          }).format(saving / 100);
          var percentEl = priceUI.querySelector('.savings');
          if (percentEl) {
            var percentLabel = '−' + Math.round(saving / compare * 100) + '%';
            if (percentEl.textContent.trim() !== percentLabel) {
              percentEl.textContent = percentLabel;
            }
          }
        } else {
          amountEl.textContent = '';
        }
      }

      // Turbo updates its price asynchronously after variant selection.
      if (window.jQuery) {
        window.jQuery(form).on('change.lomamoEuroSavings', 'select, input', function () {
          window.requestAnimationFrame(refresh);
        });
      } else {
        form.addEventListener('change', function () { window.requestAnimationFrame(refresh); });
      }
      var observer = new MutationObserver(function () { refresh(); });
      observer.observe(priceUI, { childList: true, subtree: true });
      window.requestAnimationFrame(refresh);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  if (window.InstantClick && typeof window.InstantClick.on === 'function') {
    window.InstantClick.on('change', init);
  }
}());
